import { useSuspenseQuery } from "@tanstack/react-query";
import { Api } from "../api.config";
import { QueryKeys } from "../LinkGen";

export const useMetaAdsCrossClientOverview = (from: string, to: string) => {
	return useSuspenseQuery({
		queryKey: QueryKeys.Integrations.MetaAds.Reporting.CrossClientOverview(
			from,
			to,
		),
		queryFn: () =>
			Api.GetMetaAdsCrossClientOverview(from, to).then((r) => r.data),
		refetchInterval: 3600000,
	});
};
